/* eslint-disable */
import Validate from "./validate.js"
import { Decimal } from "decimal.js/decimal.mjs"
/**
 * Created by chenjianbin on 2020/04/8.
 */

/**
 * 数字金额转换为中文大写数字
 * @param {*} n 【必填】需要转换的数字金额
 */
function digitalConversion(n) {
  if (Validate.isUndeFinedOrNullOrBlank(n) || isNaN(Number(n))) return n
  const fraction = ["角", "分"]
  const digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"]
  const unit = [
    ["元", "万", "亿"],
    ["", "拾", "佰", "仟"]
  ]
  const IsNum = Number(n)
  if (!isNaN(IsNum)) {
    const head = n < 0 ? "欠" : ""
    n = Math.abs(n)
    let s = ""
    for (let i = 0; i < fraction.length; i++) {
      s += (
        digit[Math.floor(((n * 100) / 10) * Math.pow(10, i)) % 10] + fraction[i]
      ).replace(/零./, "")
    }
    s = s || "整"
    n = Math.floor(n)
    for (let i = 0; i < unit[0].length && n > 0; i++) {
      let p = ""
      for (let j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p
        n = Math.floor(n / 10)
      }
      s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s
    }
    return (
      head +
      s
        .replace(/(零.)*零元/, "元")
        .replace(/(零.)+/g, "零")
        .replace(/^整$/, "零元整")
    )
  } else {
    return ""
  }
}

/**
 * 数字金额转为货币格式（10,000.00）
 * @param {*} value 【必填】数字金额
 */
function formatPrice(value, digits = null) {
  if (Validate.isUndeFinedOrNullOrBlank(value) || isNaN(Number(value))) {
    return 0.0
  }
  value = keepDecimalPlaces(value, digits)
  value = value
    .toString()
    .replace(
      digits === 0 ? /(\d{1,3})(?=(\d{3})+(?:$|\.))/g : /(\d)(?=(\d{3})+\.)/g,
      function (match, p1, p2) {
        return p1 + ","
      }
    )
  return value

  // if (Validate.isUndeFinedOrNullOrBlank(value) || isNaN(Number(value))) return '0.00'
  // if (isNaN(Number(digits))) return value
  // if (digits < 0) throw new Error('参数n不应该小于0')
  // value = Number(value)
  // value = parseFloat(value)
  // const hasDot = parseInt(value) !== value // 这里检测num是否为小数，true表示小数
  // if (hasDot) {
  //   const _length = value.toString().split('.')[1].length
  //   value = digits === 0 || !digits || _length < 2 ? value.toFixed(2) : _length < digits ? value : value.toFixed(digits)
  //   value = value.toString().replace(/(\d)(?=(\d{3})+\.)/g, function(match, p1, p2) {
  //     return p1 + ','
  //   })
  //   return value
  // }
  // value = value.toFixed(2).toString().replace(/(\d)(?=(\d{3})+\.)/g, function(match, p1, p2) {
  //   return p1 + ','
  // })
  // return value
}

/**
 * 数字转为千分符展示，并保留几位小数
 * @param {Number} value 【必填】需格式化的数字
 * @param {Number} digits【选填】保留小数位数
 * @param {Number} zero【选填】值不为数值时，是否返回空
 * @param {Number} places【选填】小数位是否补起到00 false:不补齐, true:补齐
 */
// function formatThousandthSign(value, digits = null, places = false ) {
function formatThousandthSign(
  value,
  digits = null,
  zero = true,
  places = false
) {
  value = keepDecimalPlaces(value, digits, zero, places)
  value = value
    .toString()
    .replace(
      digits === 0 ? /(\d{1,3})(?=(\d{3})+(?:$|\.))/g : /(\d)(?=(\d{3})+\.)/g,
      function (match, p1, p2) {
        return p1 + ","
      }
    )
  return value

  // if (typeof(value) !== 'number' && !zero) return ''
  // if (!value) return '0'
  // if (isNaN(Number(digits))) return value
  // if (digits < 0) throw new Error('参数n不应该小于0')
  // value = Number(value)
  // value = parseFloat(value)
  // const hasDot = parseInt(value) !== value // 这里检测num是否为小数，true表示小数
  // if (hasDot) {
  //   const _length = value.toString().split('.')[1].length
  //   value = digits === 0 ? value.toFixed(0) : !digits || _length < 2 ? value.toFixed(2) : _length < digits ? value : value.toFixed(digits)
  //   value = digits === 0 ? parseFloat(value) : parseFloat(value) === parseFloat(Number(value).toFixed(2)) ? Number(value).toFixed(2) : value
  //   value = value.toString().replace(digits === 0 ? /(\d{1,3})(?=(\d{3})+(?:$|\.))/g : /(\d)(?=(\d{3})+\.)/g, function(match, p1, p2) {
  //     // value = value.toString().replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, function(match, p1, p2) {
  //     return p1 + ','
  //   })
  //   return value
  // }
  // if (digits){
  //   value = value.toFixed(digits < 2 && places ? digits : 2)
  //   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  // }
  // value = value.toString().replace(digits === 0 ? /(\d{1,3})(?=(\d{3})+(?:$|\.))/g : /(\d)(?=(\d{3})+\.)/g, function(match, p1, p2) {
  //   return p1 + ','
  // })
  // return value

  // if (!value) return '0'
  // if (isNaN(Number(digits))) return value
  // if (digits < 0) throw new Error('参数n不应该小于0')
  // // console.log(value,'value')
  // var hasDot = parseInt(value) !== value // 这里检测num是否为小数，true表示小数
  // if (digits) {
  //   value = Number(value)
  //   value = digits === 0 ? value.toFixed(digits) + '.' : hasDot ? (digits ? value.toFixed(digits) : value) : value.toFixed(digits)
  //   value = value.toString().replace(/(\d)(?=(\d{3})+\.)/g, function(match, p1, p2) {
  //     return p1 + ','
  //   })
  //   if (digits === 0 || (!hasDot && !digits)) {
  //     // 如果n为0或者传入的num是整数并且没有指定整数的保留位数，则去掉前面操作中的小数位
  //     value = value.substring(0, value.indexOf('.'))
  //   }
  //   return value
  // }
  // if (hasDot) {
  //   value = value.toString().replace(/(\d)(?=(\d{3})+\.)/g, function(match, p1, p2) {
  //     return p1 + ','
  //   })
  //   return value
  // }
  // return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

  // if (Validate.isUndeFinedOrNullOrBlank(value) || isNaN(Number(value))) return value
  // const tempV = value.toString()
  // if (tempV.indexOf('.') > -1) {
  //   let valArr = tempV.split('.')
  //   if (digits) {
  //     if (digits === 0) {
  //       return valArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  //     } else if (digits > 0) {
  //       return valArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '.' + valArr[1].substr(0, digits)
  //     }
  //   }
  //   return valArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '.' + valArr[1]
  // } else {
  //   if (digits) {
  //     return Number(tempV).toFixed(digits).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  //   }
  //   return tempV.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  // }
}
/**
 * 数字保留几位小数
 * @param {Number} value 【必填】需格式化的数字
 * @param {Number} digits【选填】保留小数位数
 */
function keepDecimalPlaces(
  value,
  digits = null,
  zero = true,
  places = false,
  integerDigits = 2
) {
  if (isNaN(Number(value)) && !zero) return ""
  if (Validate.isUndeFinedOrNullOrBlank(value) || isNaN(Number(value))) return 0 // value为空或者不为数值 返回0
  if (isNaN(Number(digits)) || digits < 0) return value // digits不为数值或为负数 返回value
  // value = parseFloat(value)
  const hasDot = Validate.isDot(value) // 检测是否是小数
  if (hasDot) {
    value = new Decimal(value).toFixed(
      digits === null ? 2 : hasDot < digits ? (hasDot < 2 ? 2 : hasDot) : digits
    )
    return value
  }
  if (digits === 0) {
    value = new Decimal(value).toFixed(digits)
  } else {
    value = places ? value : new Decimal(value).toFixed(integerDigits)
  }
  return value

  // if (Validate.isUndeFinedOrNullOrBlank(value) || isNaN(Number(value))) return '0.00'
  // if (isNaN(Number(digits))) return value
  // if (digits < 0) throw new Error('参数n不应该小于0')
  // value = Number(value)
  // value = parseFloat(value)
  // const hasDot = parseInt(value) !== value // 这里检测num是否为小数，true表示小数
  // if (hasDot) {
  //   const _length = value.toString().split('.')[1].length
  //   value = digits === 0 ? value.toFixed(0) : !digits || _length < 2 ? value.toFixed(2) : _length < digits ? value : value.toFixed(digits)
  //   value = digits === 0 ? parseFloat(value) : parseFloat(value) === parseFloat(Number(value).toFixed(2)) ? Number(value).toFixed(2) : value
  //   return value
  // }
  // return value.toFixed(2)

  // if (!value) return 0
  // if (typeof value !== 'number') return value
  // if (digits < 0) throw new Error('参数n不应该小于0')
  // var hasDot = parseInt(value) !== value // 这里检测num是否为小数，true表示小数
  // if (digits) {
  //   value = digits === 0
  //     ? value.toFixed(digits) + '.'
  //     : hasDot
  //       ? (digits ? value.toFixed(digits) : value)
  //       : value.toFixed(digits)
  //   if (digits === 0 || (!hasDot && !digits)) {
  //     // 如果n为0或者传入的num是整数并且没有指定整数的保留位数，则去掉前面操作中的小数位
  //     value = value.substring(0, value.indexOf('.'))
  //   }
  //   return value
  // }
}

/**
 * 货币格式（千分符）转为数字
 * @param {*} value 【必填】货币格式
 */
function toNum(value) {
  if (Validate.isUndeFinedOrNullOrBlank(value)) return value
  const reg = new RegExp(",", "g")
  const tempArr = value.toString().split(".")
  if (tempArr[1] === "00") {
    return tempArr[0].replace(reg, "")
  }
  return value.toString().replace(reg, "")
}

/**
 * 数字金额补齐两位小数
 * @param {*} value 【必填】数字金额
 */
function toFixNum(value) {
  if (Validate.isUndeFinedOrNullOrBlank(value) || isNaN(Number(value))) {
    return value
  }
  return (Number(value) / 1).toFixed(2)
}

/**
 * 数字转为百分比
 * @param {*} value 【必填】数字
 */
function toPercent(value, digits = null) {
  if (Validate.isUndeFinedOrNullOrBlank(value) || isNaN(Number(value))) {
    return value
  }
  let afterPointLen = 0
  if (value.toString().indexOf(".") > -1) {
    afterPointLen = value.toString().split(".")[1].length
  }
  let str
  if (afterPointLen > 1) {
    str = (Number(value) * 100).toFixed(digits || afterPointLen - 2)
  } else if (afterPointLen === 1) {
    str = (Number(value) * 100).toFixed(0)
  } else {
    str = Number(value) * 100
  }
  str += "%"
  return str
}

/**
 * 百分比转数字
 * @param {*} value 【必填】百分数
 */
function toPoint(value) {
  if (Validate.isUndeFinedOrNullOrBlank(value)) return value
  let str = `${value}`.replace("%", "")
  str = accDiv(str, 100)
  return str
}

/**
 * 隐藏手机号中间4位
 * @param {*} phoneNum 【必填】手机号
 */
function hidePhoneNum(phoneNum) {
  const reg = /(\d{3})\d{4}(\d{4})/
  return phoneNum.toString().replace(reg, "$1****$2")
}

/**
 * 去除字符串左侧空格
 * @param {*} str 【必填】字符串
 */
function trimLeft(str) {
  return str.replace(/^\s*/, "")
}

/**
 * 去除字符串右侧空格
 * @param {*} str 【必填】字符串
 */
function trimRight(str) {
  return str.replace(/(\s*$)/g, "")
}

/**
 * 去除字符串两侧空格
 * @param {*} str 【必填】字符串
 */
function trimSide(str) {
  return str.replace(/^\s*|\s*$/g, "")
}

/**
 * 去除字符串所有空格
 * @param {*} str 【必填】字符串
 */
function trimAll(str) {
  return str.replace(/\s*/g, "")
}

/**
 * 在数组指定位置插入元素
 * @param {*} arr 【必填】要插入的数组
 * @param {*} index 【必填】要插入的位置
 * @param {*} value 【必填】要插入的元素
 */
function arrayInsert(arr, index, value) {
  const tempArr = arr
  tempArr.splice(index, 0, value)
  return tempArr
}

/**
 * 数组深拷贝
 * @param {*} arr 【必填】要拷贝的数组
 */
function arrDeepCopy(arr) {
  const sourceCopy = []
  for (const item in arr) {
    sourceCopy[item] =
      typeof arr[item] === "object" ? arrDeepCopy(arr[item]) : arr[item]
  }
  return sourceCopy
}

/**
 * 除法精度计算
 * @param {*} arg1 【必填】参数1
 * @param {*} arg2 【必填】参数2
 */
function accDiv(arg1, arg2) {
  var t1 = 0
  var t2 = 0
  var r1
  var r2
  try {
    t1 = arg1.toString().split(".")[1].length
  } catch (e) {}
  try {
    t2 = arg2.toString().split(".")[1].length
  } catch (e) {}
  r1 = Number(arg1.toString().replace(".", ""))
  r2 = Number(arg2.toString().replace(".", ""))
  return accMul(r1 / r2, Math.pow(10, t2 - t1))
}

/**
 * 乘法精度计算
 * @param {*} arg1 【必填】参数1
 * @param {*} arg2 【必填】参数2
 */
function accMul(arg1, arg2) {
  var m = 0
  var s1 = arg1.toString()
  var s2 = arg2.toString()
  try {
    m += s1.split(".")[1].length
  } catch (e) {}
  try {
    m += s2.split(".")[1].length
  } catch (e) {}
  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    Math.pow(10, m)
  )
}

/**
 * 加法精度计算
 * @param {*} arg1 【必填】参数1
 * @param {*} arg2 【必填】参数2
 */
function accAdd(arg1, arg2) {
  var r1, r2, m
  try {
    r1 = arg1.toString().split(".")[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split(".")[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}

/**
 * 减法精度计算
 * @param {*} arg1 【必填】参数1
 * @param {*} arg2 【必填】参数2
 */
function accSubtr(arg1, arg2) {
  var r1, r2, m, n
  try {
    r1 = arg1.toString().split(".")[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split(".")[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  n = r1 >= r2 ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}

// template methods
/**
 * 获取传递参数对象
 * @param {*} url
 */
function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf("?") + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {Sting} input value
 * @returns {number} output value
 */
function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xdc00 && code <= 0xdfff) i--
  }
  return s
}

/**
 * 清理数组（去除空值）
 * @param {*} actual
 */
function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

function param(json) {
  if (!json) return ""
  return cleanArray(
    Object.keys(json).map((key) => {
      if (json[key] === undefined) return ""
      return encodeURIComponent(key) + "=" + encodeURIComponent(json[key])
    })
  ).join("&")
}

function param2Obj(url) {
  const search = url.split("?")[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, " ") +
      '"}'
  )
}

function html2Text(val) {
  const div = document.createElement("div")
  div.innerHTML = val
  return div.textContent || div.innerText
}

function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== "object") {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach((property) => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === "object") {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += "" + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

const pickerOptions = [
  {
    text: "今天",
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit("pick", [start, end])
    }
  },
  {
    text: "最近一周",
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit("pick", [start, end])
    }
  },
  {
    text: "最近一个月",
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit("pick", [start, end])
    }
  },
  {
    text: "最近三个月",
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit("pick", [start, end])
    }
  }
]

function getTime(type) {
  if (type === "start") {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "deepClone")
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

function createUniqueString() {
  const timestamp = +new Date() + ""
  const randomNum = parseInt((1 + Math.random()) * 65536) + ""
  return (+(randomNum + timestamp)).toString(32)
}

function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"))
}

function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += " " + cls
}

function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)")
    ele.className = ele.className.replace(reg, " ")
  }
}
/**
 * @param {Array}  要交换的数组
 * @param {number} 交换元素下标
 * @param {number} 交换元素下标
 * @return {Array} 交换后数组
 */
function swapArray(arr, index1, index2) {
  arr[index1] = arr.splice(index2, 1, arr[index1])[0]
  return arr
}

// 取得字典对应中文
function getCnDitc(
  params,
  ditc = [],
  key = "",
  skey = "sCodeValue",
  sName = "sCodeName"
) {
  if (key === "") return
  for (let index = 0; index < ditc.length; index++) {
    const element = ditc[index]
    if (element[skey] === params.data[key]) {
      return element[sName]
    }
  }
}

/**
 * 过滤对象空属性
 * @param {Object}  过滤对象
 */
export function filterObj(obj) {
  for (const key in obj) {
    if (
      obj.hasOwnProperty(key) &&
      (obj[key] === null || obj[key] === undefined || obj[key] === "")
    ) {
      delete obj[key] // 删除没有的属性和空的
    }
  }
  return obj
}

// 工具函数
// 判断是否带有小数并获取小数长度
function isDot(value) {
  const reg = /^(-|\+)?\d+\.\d*$/
  if (reg.test(value)) {
    return value.toString().split(".")[1].length
  }
  return reg.test(value)
}
// 判断是否为数字，检查其是否为有限值,对于NaN，Infinity或-Infinity的数字，返回false。
function checkNumber(params) {
  return !Number.isFinite(params)
}
// 错误提示函数
function warn(text) {
  console.error(text)
}

/**
 * 数字保留几位小数
 * @param {Number} value 【必填】需格式化的数字
 * @param {Number} digits【选填】保留小数位数
 * @param {Number} places【选填】小数位是否补起到00 false:不补齐, true:补齐
 * @param {Number} zero【选填】值不为数值时，是否返回空
 * @param {boolean} lowerDigits 【选填】用于判断在百分比函数使用时fixed为当前小数位
 */
function toDecimalPlaces(
  value,
  digits = 2,
  places = false,
  zero = true,
  lowerDigits = false
) {
  if (checkNumber(value) || (isNaN(Number(value)) && !!value)) {
    //值不为数值时是否返回空 zero true:返回空 false返回0
    warn("参数value无法被解析为有效的数值类型")
    return zero ? "" : 0
  }
  if (checkNumber(digits) || digits < 0) {
    // digits不为数值或为负数 返回value
    warn("参数digits无法被解析为有效的数值类型")
    return value
  }
  const hasDot = isDot(value) // 检测是否是小数
  // 是浮点数 通过传入的digits fixed小数位 不是浮点数 判断是否补全
  // 用于处理百分比函数调用时不补0用
  let flag = lowerDigits ? hasDot : hasDot < 2 ? 2 : hasDot
  if (hasDot) {
    value = value.toFixed(
      hasDot < digits ? (places ? digits : flag) : lowerDigits ? digits : hasDot
    )
    return value
  }
  value = places ? value.toFixed(digits) : value
  return value
}
// let keepDecimalPlacesValue = keepDecimalPlaces(0.1, 3)
/*
keepDecimalPlaces 函数返回值测试
1111.5555, 0   1112
1111.4444, 0   1111
1111.5555, 1   1111.6
1111.4444, 1   1111.4
1111.5555, 2   1111.56
1111.4444, 2   1111.44
0.1, 0          0
0.1, 1          0.1
0.1, 2          0.10
0.1, 3          0.100
*/

/**
 * 数字转为千分符展示，并保留几位小数
 * @param {Number} value 【必填】需格式化的数字
 * @param {Number} digits【选填】保留小数位数
 * @param {Number} places【选填】小数位是否补起到00 false:不补齐, true:补齐
 * @param {Number} zero【选填】值不为数值时，是否返回空
 */
function toThousandthSign(value, digits = 2, places = false, zero = true) {
  value = toDecimalPlaces(value, digits, places, zero)
  const [integer, point] = value.toString().split(".")
  let res
  const reg = /(\d{3})(?=\d)/g
  let newStr = integer
    .split("")
    .reverse()
    .join("")
    .replace(reg, (match, $1) => {
      return match + ","
    })
  newStr = newStr.split("").reverse().join("")
  point ? (res = newStr + "." + point) : (res = newStr)
  return res
}
// let formatThousandthSignValue = formatThousandthSign(0.1, 3)
// console.log(formatThousandthSignValue)
/*
// 函数返回值测试
1111.5555, 0    1,112
1111.4444, 0    1,111
1111.5555, 1    1,111.6
1111.4444, 1    1,111.4
1111.5555, 2    1,111.56
1111.4444, 2    1,111.44
0.1, 0          0
0.1, 1          0.1
0.1, 2          0.10
0.1, 3          0.100
*/

/**
 * 浮点数转百分比
 * @param {Number} value 【必填】需格式化的数字
 * @param {Number} digits【选填】保留小数位数
 */
function toPercentage(value, digits = 2) {
  function isUndeFinedOrNullOrBlank(str) {
    return (
      str === undefined ||
      str == null ||
      (typeof str === "string" && str.trim() === "")
    )
  }
  if (isUndeFinedOrNullOrBlank(value) || isNaN(Number(value))) {
    return value
  }
  return toDecimalPlaces(value * 100, digits, false, true, true) + "%"
}

export default {
  getQueryObject,
  byteLength,
  cleanArray,
  param,
  param2Obj,
  html2Text,
  objectMerge,
  getTime,
  debounce,
  deepClone,
  uniqueArr,
  createUniqueString,
  toggleClass,
  hasClass,
  addClass,
  removeClass,
  digitalConversion,
  formatPrice,
  formatThousandthSign,
  toNum,
  toFixNum,
  toPercent,
  toPoint,
  hidePhoneNum,
  trimLeft,
  trimRight,
  trimSide,
  trimAll,
  arrayInsert,
  arrDeepCopy,
  accDiv,
  accMul,
  accAdd,
  accSubtr,
  swapArray,
  filterObj,
  getCnDitc,
  keepDecimalPlaces,
  toPercentage,
  toThousandthSign,
  toDecimalPlaces
}
